module.exports = __webpack_public_path__ + "img/expand-down.cfcc8357.svg";